
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5685',
  depVersions: {
  "data-privacy-request-ui": "static-1.5685",
  "client-types": "static-1.488",
  "data-fetching-client": "static-1.9827",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8190",
  "hub-http-shared-msw-handlers": "static-1.10389",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11646",
  "I18n": "static-7.1645",
  "jasmine-runner": "static-1.6625",
  "quartz": "static-1.7253",
  "react-dlb": "static-1.83",
  "rpc-client-utils": "static-1.4827",
  "ui-components-test-utils": "static-1.5783",
  "UIComponents": "static-3.8592",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.88",
  "foundations-assets": "static-1.5043",
  "foundations-components": "static-1.8265",
  "foundations-components-test-utils": "static-1.5748",
  "foundations-theming": "static-1.4608",
  "hub-http": "static-1.6389",
  "quartz-config": "static-1.1031",
  "quartz-core": "static-1.6472",
  "quartz-routing": "static-1.683",
  "quick-fetch": "static-1.4038",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-rhumb": "static-1-track-cwv-per-soft-navigation.19",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11318",
  "usage-tracker": "static-1.7521",
  "usage-tracker-anonymous": "static-1.5938",
  "usage-tracker-core": "static-1.7371",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3522",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3530",
  "quartz-webpack": "static-1.3477",
  "bend-plugin-quartz-routing": "static-1.331",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.84",
  "HeadJS": "static-2.777",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3301",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "ts-schema": "static-1.4202",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.85",
  "react-utils": "static-2.5462",
  "StyleGuideUI": "static-3.491",
  "jasmine": "static-4.4493",
  "bend-plugin-chirp-manifest": "static-1.237",
  "chirp-fetch": "static-1.2057",
  "HubStyle": "static-2.11953",
  "ui-addon-draggable": "static-3.4927",
  "cssUtils": "static-1.842",
  "hs-story-utils": "static-1.9594",
  "icons": "static-2.665",
  "react-create-root-preference": "static-1.45",
  "react-select-plus": "static-1.107",
  "react-virtualized": "static-2.101",
  "ui-images": "static-2.1205",
  "bend-plugin-foundations-components": "static-1.4534",
  "floating-ui": "static-1.59",
  "foundations-theming-specialty": "static-1.2324",
  "react-aria": "static-1.68",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2273",
  "ui-fonts": "static-1.908",
  "foundations-components-legacy": "static-1.1290",
  "bend-plugin-foundations-theming": "static-1.3091",
  "foundations-theming-base": "static-1.3593",
  "stylex": "static-1.36",
  "hs-locale-management": "static-1.203",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.852",
  "hubspotter-http": "static-1.4772",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.928",
  "quartz-head": "static-1.918",
  "quartz-i18n": "static-1.928",
  "quartz-test": "static-1.928",
  "quartz-tracking": "static-1.632",
  "trellis-components": "static-1.2292",
  "usage-tracker-container": "static-1.7511",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3301",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.73",
  "sassPrefix": "static-1.159",
  "hubspotter-http-shared-msw-handlers": "static-1.10387",
  "usage-tracker-session-replay": "static-1.5207",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1118",
  "tanstack-virtual": "static-1.32",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5685",
  "client-types": "/client-types/static-1.488",
  "data-fetching-client": "/data-fetching-client/static-1.9827",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8190",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10389",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11646",
  "I18n": "/I18n/static-7.1645",
  "jasmine-runner": "/jasmine-runner/static-1.6625",
  "quartz": "/quartz/static-1.7253",
  "react-dlb": "/react-dlb/static-1.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.4827",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5783",
  "UIComponents": "/UIComponents/static-3.8592",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "foundations-assets": "/foundations-assets/static-1.5043",
  "foundations-components": "/foundations-components/static-1.8265",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5748",
  "foundations-theming": "/foundations-theming/static-1.4608",
  "hub-http": "/hub-http/static-1.6389",
  "quartz-config": "/quartz-config/static-1.1031",
  "quartz-core": "/quartz-core/static-1.6472",
  "quartz-routing": "/quartz-routing/static-1.683",
  "quick-fetch": "/quick-fetch/static-1.4038",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-rhumb": "/react-rhumb/static-1-track-cwv-per-soft-navigation.19",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11318",
  "usage-tracker": "/usage-tracker/static-1.7521",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5938",
  "usage-tracker-core": "/usage-tracker-core/static-1.7371",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3522",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3530",
  "quartz-webpack": "/quartz-webpack/static-1.3477",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.331",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.84",
  "HeadJS": "/HeadJS/static-2.777",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3301",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "ts-schema": "/ts-schema/static-1.4202",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.85",
  "react-utils": "/react-utils/static-2.5462",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "jasmine": "/jasmine/static-4.4493",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.237",
  "chirp-fetch": "/chirp-fetch/static-1.2057",
  "HubStyle": "/HubStyle/static-2.11953",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4927",
  "cssUtils": "/cssUtils/static-1.842",
  "hs-story-utils": "/hs-story-utils/static-1.9594",
  "icons": "/icons/static-2.665",
  "react-create-root-preference": "/react-create-root-preference/static-1.45",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-virtualized": "/react-virtualized/static-2.101",
  "ui-images": "/ui-images/static-2.1205",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4534",
  "floating-ui": "/floating-ui/static-1.59",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2324",
  "react-aria": "/react-aria/static-1.68",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2273",
  "ui-fonts": "/ui-fonts/static-1.908",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1290",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3091",
  "foundations-theming-base": "/foundations-theming-base/static-1.3593",
  "stylex": "/stylex/static-1.36",
  "hs-locale-management": "/hs-locale-management/static-1.203",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.852",
  "hubspotter-http": "/hubspotter-http/static-1.4772",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.928",
  "quartz-head": "/quartz-head/static-1.918",
  "quartz-i18n": "/quartz-i18n/static-1.928",
  "quartz-test": "/quartz-test/static-1.928",
  "quartz-tracking": "/quartz-tracking/static-1.632",
  "trellis-components": "/trellis-components/static-1.2292",
  "usage-tracker-container": "/usage-tracker-container/static-1.7511",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.73",
  "sassPrefix": "/sassPrefix/static-1.159",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10387",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5207",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1118",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
